import React from 'react';
import { useContext } from 'react';
import { Listbox } from '@headlessui/react';
import classNames from 'classnames';
import Icon from '../../icon';
import { enrollmentContext } from '../../../context/enrollment/enrollment-context';
import { updateValue } from '../common-functions';
import { IChoiceInputProps } from '../input';
import { InputLabel } from '../common-components/input-label';
import { ErrorShower } from '../common-components/error-shower';

export const SelectBox: React.FC<IChoiceInputProps> = ({
	label,
	name,
	required,
	value,
	options,
	errors,
	register,
	ariaLabel,
	help,
	onChange,
	placeholder,
	className,
}) => {
	const enrollmentCtxt = useContext(enrollmentContext);
	return (
		<div className={'text-font ' + className}>
			<InputLabel
				ariaLabel={ariaLabel}
				label={label}
				required={required}
				errors={errors}
				name={name}
				help={help}
			/>
			<Listbox
				name={name}
				value={value}
				onChange={(data) => {
					updateValue(enrollmentCtxt, name, data);
					if (onChange) {
						onChange(data);
					}
				}}>
				{({ open }) => (
					<div
						className={classNames('relative mt-2', {
							'border-2 border-error': errors[name],
						})}>
						<Listbox.Button className="bg-white relative px-7 h-14 text-left rounded-full w-full shadow-leap focus:ring-2 focus:ring-brand outline-none">
							<span
								className={classNames('block truncate font-semibold', {
									'text-font-400': !value,
								})}>
								{value || placeholder}
							</span>
							<span className="absolute inset-y-0 right-0 flex items-center pr-6 pointer-events-none">
								<Icon
									aria-hidden="true"
									className="h-4 w-4 text-font mt-2"
									type={open ? 'chevronUp' : 'chevronDown'}
								/>
							</span>
						</Listbox.Button>
						<Listbox.Options className="absolute z-10 mt-1 max-h-60 w-full bg-neutral overflow-auto rounded-md py-1 text-base shadow-leap ring-1 ring-brand ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
							{options?.map((option, index) => (
								<Listbox.Option
									className={({ active }) =>
										`text-font cursor-default relative py-1 pl-3 pr-9 ${
											active
												? 'text-font-contrast font-bold bg-brand rounded-md mx-1'
												: 'font-semibold'
										}`
									}
									key={index}
									value={option.value}>
									{option.value}
								</Listbox.Option>
							))}
						</Listbox.Options>
					</div>
				)}
			</Listbox>
			{errors && errors[name as string] && (
				<div className="mt-2">
					<ErrorShower errors={errors} name={name} />
				</div>
			)}
		</div>
	);
};
